import { render, staticRenderFns } from "./keepOnRecord.vue?vue&type=template&id=32e02ae0&scoped=true"
import script from "./keepOnRecord.vue?vue&type=script&lang=js"
export * from "./keepOnRecord.vue?vue&type=script&lang=js"
import style0 from "./keepOnRecord.vue?vue&type=style&index=0&id=32e02ae0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e02ae0",
  null
  
)

export default component.exports